import moment, { Moment } from "moment";
import { notificationCategoryOf, notificationTagOf } from "../constants/notificationConstant";
import { getNotificationUrl } from "../helpers/common";
import { iNotifcation, iNotificationPayloadData, iNotificationRowModel, NotificationEventLabel } from "../types/notificationTypes";

export const NOTIFICATION_EVENT_LABELS: Record<NotificationEventLabel, string> = {
	B2B: "B2B",
	B2C: "B2C",
	PREPAID: "Prepaid",
};

export const notificationUrlOf = (data?: iNotificationPayloadData) => (data ? getNotificationUrl(data) : "");

export const toNotificationRowModel = (notification: iNotifcation): iNotificationRowModel => {
	const type = notification.data?.type;
	const category = notificationCategoryOf({ category: notification.category, type });
	return {
		id: notification.id,
		category,
		type,
		tag: notificationTagOf(category, type),
		eventName: notification.data?.eventName,
		eventLabel: notification.eventLabel,
		title: notification.title || "Notification",
		body: notification.data?.richDescription || notification.body || "",
		isRead: notification.isRead,
		createdAt: notification.createdAt,
		url: notificationUrlOf(notification.data),
	};
};

export const formatNotificationTime = (createdAt?: string | null, now: Moment = moment()) => {
	if (!createdAt) return "";
	const time = moment(createdAt);
	if (!time.isValid()) return "";
	const minutes = now.diff(time, "minutes");
	if (minutes < 1) return "now";
	if (minutes < 60) return `${minutes}m`;
	if (time.isSame(now, "day")) return `${now.diff(time, "hours")}h`;
	if (time.isSame(now.clone().subtract(1, "day"), "day")) return "Yesterday";
	if (time.isSameOrAfter(now.clone().startOf("week"))) return time.format("ddd");
	return time.format(time.isSame(now, "year") ? "D MMM" : "D MMM YYYY");
};

export const notificationGroupOf = (createdAt?: string | null, now: Moment = moment()) => {
	const time = moment(createdAt);
	if (!createdAt || !time.isValid()) return "Earlier";
	if (time.isSame(now, "day")) return "Today";
	if (time.isSame(now.clone().subtract(1, "day"), "day")) return "Yesterday";
	const weekStart = now.clone().startOf("week");
	if (time.isSameOrAfter(weekStart)) return "Earlier this week";
	if (time.isSameOrAfter(weekStart.clone().subtract(1, "week"))) return "Last week";
	return time.format(time.isSame(now, "year") ? "MMMM" : "MMMM YYYY");
};

export const groupNotificationsByDate = <T extends { createdAt?: string | null }>(
	items: T[],
	now: Moment = moment(),
) =>
	items.reduce<{ label: string; items: T[] }[]>((groups, item) => {
		const label = notificationGroupOf(item.createdAt, now);
		const last = groups[groups.length - 1];
		if (last?.label === label) {
			last.items.push(item);
		} else {
			groups.push({ label, items: [item] });
		}
		return groups;
	}, []);
